import React from "react";
import LecturerNav from "../../navigation/LecturerNav";

/**
 * This page presents the lecturer with information on what students have been allocated to each ot the projects that they submitted along with
 * when they will be marking those projects.
 * @returns a list of details of the final allocations the lecturer got.
 */

function LecturerViewFinalAllocation() {
    return(
        <div>
            <LecturerNav/>
            <h1>Final Allocations</h1>
        </div>
    )
}

export default LecturerViewFinalAllocation